import Service from 'src/service.js';
import store from 'store/store.js';

//var service = new Service();

export default class ReportModel {
    static getMonthNumberArray(year) {
        if (year % 4 == 0)
            return [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        return [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    }
    static getWeekDay() {
        return ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
    }
    static getIndexWeekDayEnglish(day) {
        let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        return days.indexOf(day);
    }
    static getMonthTitleArray() {
        return ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
    }
    static getTimeTrackingTotal(m, y) {
        Service.getTimeTrackigTotal(m, y);
        Service.getProjectTotal(m, y); 
    }
    static setDate(date){
        store.dispatch('dateInputClick', new Date(date.substr(3, 4), date.substr(0, 2) - 1));
    }
    static getDate(){
        let full_date = store.getters.currentDate;
        let year = full_date.substr(3, 4);
        let month = full_date.substr(0, 2) - 1;
        return [full_date, year, month];
    }
    static getHolidays(d, m, y){
        let holidays = [
            new Date(y,  0, 7, 0, 0, 0, 0).toString(),
            new Date(y, 1, 23, 0, 0, 0, 0).toString(),
            new Date(y, 2, 8, 0, 0, 0, 0).toString(),
            new Date(y, 4, 1, 0, 0, 0, 0).toString(),
            new Date(y, 4, 2, 0, 0, 0, 0).toString(),
            new Date(y, 4, 9, 0, 0, 0, 0).toString(),
            new Date(y, 5, 1, 0, 0, 0, 0).toString(),
            new Date(y, 5, 12, 0, 0, 0, 0).toString(),
            new Date(y, 10, 5, 0, 0, 0, 0).toString()
        ];
        return holidays.indexOf(new Date(y, m, d, 0, 0, 0, 0).toString());      
    }
    static setMonthDesc(){
        let date = this.getDate();
        store.dispatch('changeMonthDesc', new Date(date[1], date[2] - 1));
    }
    static setMonthAsc() {
        let date = this.getDate();
        store.dispatch('changeMonthAsc', new Date(date[1], date[2] + 1));
    }
    static getFullName(){
        return Service.getCookie('fullname');
    }
    static setDebts() {
        let date = new Date()
        Service.getDebts(date.getDate(), date.getMonth() + 1, date.getFullYear())
    }
}


// WEBPACK FOOTER //
// ./src/Report/ReportModel.js